export default __webpack_public_path__ + "static/media/19.f24d250f.jpg";